// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboards{
  height: calc( 100vh - (200px));
  display: flex;    
  align-items: center;
  justify-content: center;  
  font-size: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/Dashboards/Dashboards.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[".Dashboards{\n  height: calc( 100vh - (200px));\n  display: flex;    \n  align-items: center;\n  justify-content: center;  \n  font-size: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
